module.exports = "/images/veil-17.jpg";